import { compact, without } from 'lodash';

export const getFilteredValues = <T>(
  values: T[],
  excludedValues: (T | false)[]
): T[] => without(values, ...compact(excludedValues));
